// Mock data constants for Incumplimientos module

export const RISK_INFO = [
	{
		label: 'Riesgo Alto',
		color: 'red',
		description:
			'Corresponde a observaciones o hallazgos de fiscalización que presentan un potencial impacto legal, administrativo o reputacional significativo para la empresa, y que pueden derivar en procesos sancionatorios o judiciales.',
		criteria: [
			'La autoridad fiscalizadora deriva los antecedentes a un proceso sancionatorio, denuncia administrativa o acción judicial.',
			'Se remiten antecedentes a otra autoridad competente (por ejemplo, tribunal, SMA, municipalidad u otro servicio).',
			'Existe presunción de infracción grave a normativa sectorial, ambiental o sanitaria.',
			'La observación no contempla un plazo de subsanación inmediato, sino que queda sujeta a investigación o procedimiento administrativo.',
			'Puede implicar sanciones como multas, clausuras, suspensión de operaciones o pérdida de permisos.',
		],
	},
	{
		label: 'Riesgo Medio',
		color: 'yellow',
		description:
			'Corresponde a observaciones clasificadas por la autoridad como incumplimientos menores o no conformidades que requieren acciones correctivas dentro de un plazo formal establecido.',
		criteria: [
			'La autoridad identifica un incumplimiento menor o una observación subsanable.',
			'Se establece un plazo formal mediante acta o resolución para implementar medidas correctivas.',
			'El cierre de la observación depende de la verificación posterior por parte de la autoridad o del análisis de los antecedentes entregados.',
			'El incumplimiento no implica inmediatamente un proceso sancionatorio si se corrige dentro del plazo otorgado.',
		],
	},
	{
		label: 'Riesgo Bajo',
		color: 'green',
		description:
			'Corresponde a observaciones menores o recomendaciones formuladas por la autoridad que no constituyen incumplimientos formales o cuya subsanación es simple y de rápida acreditación que implica en algunos casos realizar los cierres en visitas posteriores.',
		criteria: [
			'La autoridad levanta una observación de carácter menor o recomendación.',
			'El cierre puede realizarse mediante envío de evidencia (fotografía, correo, documento, etc.).',
			'La autoridad indica que verificará el cierre en una próxima fiscalización o revisión administrativa.',
			'No existe procedimiento sancionatorio asociado ni plazos formales estrictos.',
		],
	},
];

/** Relationships to populate when fetching breach records from the API. */
export const BREACH_RECORD_POPULATE = [
	'breach_category',
	'breach_impact',
	'breach_risk_classification',
	'breach_origin',
];

/** Fields to request when fetching breach records from the API. */
export const BREACH_RECORD_FIELDS = [
	'_id',
	'description',
	'breach_date',
	'no_deadline',
	'inspections_id',
	'breach_category',
	'breach_impact',
	'breach_risk_classification',
	'breach_origin',
	'finding_closure_file_id',
];